module.exports = __webpack_public_path__ + "img/1495636313.f195353a.jpg";